import React, { Component } from 'react';
import './Login.css';
import Alert from '@material-ui/lab/Alert';

// redux
import {
  isAuthenticatedSelector,
  showLicenseDialogSelector,
  tokenSelector,
} from '../../redux/selectors/auth';
import { authLogin } from '../../redux/actions/auth';
import withShipment from '../../withShipment';
import ErrorFeedbackBar from '../../components/global/ErrorFeedbackBar';
import { activateLicenseKey } from '../../redux/actions/settings';
import {
  hideLicenseDialog,
  showLicenseDialog,
} from '../../redux/actions/global';
import { InputAdornment, IconButton } from '@material-ui/core';
import {
  Visibility,
  VisibilityOff,
  EmailOutlined,
  LockOutlined,
} from '@material-ui/icons';

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  CircularProgress,
  TextField,
  Button,
  Typography,
  Box,
} from '@material-ui/core';

class Login extends Component {
  state = {
    username: '',
    password: '',
    display: 'none',
    loading: false,
    key: '',
    showPassword: false,
  };

  handle = (event) => {
    event.preventDefault();
    const state = { ...this.state };
    state[event.target.name] = event.target.value;
    this.setState(state);
  };

  handleClickShowPassword = () => {
    this.setState((prevState) => ({ showPassword: !prevState.showPassword }));
  };

  handleLogin = (event) => {
    event.preventDefault();
    const { username, password } = this.state;

    if (!username || !password) {
      this.setState({ display: '' });
      return;
    }

    this.setState({ loading: true, display: 'none' });

    this.props.authLogin(username, password, this.props.history);

    setTimeout(() => {
      if (this.mounted) {
        this.setState({
          loading: false,
          display: this.props.isAuthenticated ? 'none' : '',
        });
      }
    }, 2500);
  };

  componentDidMount() {
    this.mounted = true;
  }
  componentWillUnmount() {
    this.mounted = false;
  }

  render() {
    return (
      <div className="login-page">
        <ErrorFeedbackBar />

        <aside className="login-brand-panel">
          <div className="login-glow" />
          <div className="login-grid" />

          <div className="login-brand-content">
            <img
              src={`${process.env.PUBLIC_URL || ''}/nube-data.svg`}
              alt="NuVe System"
              className="login-logo"
            />
            <h1 className="login-brand-title">NuVe System</h1>
          </div>
        </aside>

        <main className="login-form-panel">
          <div className="login-form-card">
            <div className="login-form-header">
              <h2 className="login-form-title">Welcome back</h2>
              <p className="login-form-subtitle">
                Sign in to access your dashboard
              </p>
            </div>

            <form
              className="login-form-fields"
              onSubmit={this.handleLogin}
              noValidate
            >
              <TextField
                label="Email"
                variant="outlined"
                name="username"
                fullWidth
                autoComplete="email"
                placeholder="you@company.com"
                InputLabelProps={{ shrink: true }}
                value={this.state.username}
                onChange={this.handle}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <EmailOutlined />
                    </InputAdornment>
                  ),
                }}
              />

              <TextField
                label="Password"
                type={this.state.showPassword ? 'text' : 'password'}
                variant="outlined"
                name="password"
                fullWidth
                autoComplete="current-password"
                placeholder="••••••••"
                InputLabelProps={{ shrink: true }}
                value={this.state.password}
                onChange={this.handle}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <LockOutlined />
                    </InputAdornment>
                  ),
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={this.handleClickShowPassword}
                        edge="end"
                        size="small"
                        aria-label="toggle password visibility"
                      >
                        {this.state.showPassword ? (
                          <VisibilityOff />
                        ) : (
                          <Visibility />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />

              <Alert
                className="login-error"
                style={{ display: this.state.display }}
                severity="error"
              >
                Login failed. Please check your credentials.
              </Alert>

              {!this.state.loading ? (
                <Button
                  type="submit"
                  variant="contained"
                  className="login-submit-btn"
                  onClick={this.handleLogin}
                  disableElevation
                >
                  Sign in
                </Button>
              ) : (
                <div className="login-loading">
                  <CircularProgress size={28} />
                </div>
              )}
            </form>

            <div className="login-form-footer">
              <span>Trouble signing in? Contact your administrator.</span>
            </div>
          </div>
        </main>

        <Dialog
          open={this.props.showDialog}
          onClose={this.props.hideLicenseDialog}
          maxWidth="sm"
          fullWidth
          PaperProps={{
            style: { borderRadius: 16, padding: '8px 4px' },
          }}
        >
          <DialogTitle disableTypography>
            <Typography
              variant="h6"
              style={{ color: '#d32f2f', fontWeight: 600 }}
            >
              Company Account Expired
            </Typography>
            <Typography variant="body2" color="textSecondary">
              Please enter your new license key to reactivate your account.
            </Typography>
          </DialogTitle>

          <DialogContent>
            <Box mt={2}>
              <TextField
                label="License Key"
                variant="outlined"
                fullWidth
                InputLabelProps={{ shrink: true }}
                value={this.state.key || ''}
                onChange={(e) => this.setState({ key: e.target.value })}
              />
            </Box>
          </DialogContent>

          <DialogActions style={{ padding: '16px 24px' }}>
            <Button
              onClick={this.props.hideLicenseDialog}
              style={{ fontWeight: 500 }}
            >
              Cancel
            </Button>
            <Button
              color="primary"
              variant="contained"
              style={{ fontWeight: 500 }}
              onClick={() => {
                const { username, password, key } = this.state;
                this.props.activateLicenseKey({ serialKey: key }, (success) => {
                  if (success === true && username && password) {
                    this.setState({ loading: true, display: 'none' });
                    this.props.authLogin(
                      username,
                      password,
                      this.props.history
                    );
                  }
                });
                this.props.hideLicenseDialog();
              }}
            >
              Activate
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  isAuthenticated: isAuthenticatedSelector(state),
  token: tokenSelector(state),
  showDialog: showLicenseDialogSelector(state),
});

const actionCreators = {
  authLogin,
  activateLicenseKey,
  showLicenseDialog,
  hideLicenseDialog,
};

export default withShipment({ mapStateToProps, actionCreators }, Login);
